/**
 * Role Entity Schemas
 *
 * Mirrors the Prisma Role + RoleCapability models. Used by the web
 * admin role-management UI and any client consuming the
 * /v1/authorization/roles endpoints (U6).
 */

import { z } from 'zod'
import { CapabilityKeySchema } from './capability-key'

export const RoleKindSchema = z.enum(['PLATFORM_PRESET', 'SCHOOL_CUSTOM'])
export type RoleKind = z.infer<typeof RoleKindSchema>

export const RoleSchema = z.object({
  id: z.string().describe('Role public ID (cuid)'),
  schoolId: z.string().nullable().describe('School public ID. Null for PLATFORM_PRESET roles.'),
  name: z.string(),
  description: z.string().nullable(),
  kind: RoleKindSchema,
  clonedFromRoleId: z
    .string()
    .nullable()
    .describe('If kind=SCHOOL_CUSTOM and this role was cloned from a preset, the preset role public ID.'),
  capabilities: z.array(CapabilityKeySchema),
  createdAt: z.string().describe('ISO timestamp'),
  updatedAt: z.string().describe('ISO timestamp')
})

export type Role = z.infer<typeof RoleSchema>

export const RoleSummarySchema = RoleSchema.pick({
  id: true,
  name: true,
  description: true,
  kind: true,
  capabilities: true
})
export type RoleSummary = z.infer<typeof RoleSummarySchema>
